import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppModeService } from '../../../angular-wallet-base/services/app-mode.service';
@Component({
  selector: 'setup-home',
  templateUrl: 'setup-home.page.html',
  styleUrls: ['setup-home.page.scss']
})
export class SetupHome {
  @ViewChild('slide', { static: true }) slideContainer;
  public totalPages = [1, 2, 3, 4];
  public skipSlides = false;
  public isDesktopMode;

  constructor(
    private route: ActivatedRoute,
    private appMode: AppModeService,
  ) {
    this.skipSlides = this.route.snapshot.queryParams['skip'] ? true : false;
    this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);
  }

  ngAfterViewInit() {
    this.stylizeDots();
    if(this.skipSlides) {
      this.slideContainer.slideTo(4);
    }
  }

  stylizeDots() {
    // Why stylizing using JS? Because i tried every single way to apply styles to it using CSS and didn't work
    // Probably using some sort of shadow DOM? Browser is not explicit about it, but it just wont work with anything i pass to it
   /* const slide: any = document.querySelectorAll('.swiper-pagination')[0];
    const dots = slide.querySelectorAll('.swiper-pagination-bullet');
    const activeDot = slide.querySelector('.swiper-pagination-bullet-active');

    if (!activeDot) {
      return setTimeout(this.stylizeDots.bind(this), 50);
    }

    // Apply styles
    slide.style.top = '68%';

    dots.forEach(dot => {
      dot.style.background = '#BBD1EB33';
      dot.style['border-radius'] = '';
      dot.style.width = '';
    });

    activeDot.style.background = 'var(--ion-color-light)';
    activeDot.style['border-radius'] = '4px';
    activeDot.style.width = '21px';*/
  }

  goNext() {
    this.slideContainer.slideNext();
  }
}
